import React, { useState } from "react";
import { DocumentArrowUpIcon } from "@heroicons/react/24/solid";

interface DropzoneProps {
  onFileUpload: (fileData: any) => void; // Replace 'any' with the appropriate type for your file data
}

const Dropzone: React.FC<DropzoneProps> = ({ onFileUpload }) => {
  const [file, setFile] = useState<File | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files && e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      convertFileToJson(selectedFile);
    }
  };

  const convertFileToJson = (selectedFile: File) => {
    const reader = new FileReader();
    reader.readAsText(selectedFile);
    reader.onload = () => {
      const fileData = JSON.parse(reader.result as string);
      onFileUpload(fileData);
    };
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const selectedFile = e.dataTransfer.files && e.dataTransfer.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      convertFileToJson(selectedFile);
    }
  };

  return (
    <div className="flex flex-col items-center justify-top min-h-[calc(100vh-5rem)] w-full bg-gradient-to-br from-accent to-primary">
      <div className="card w-3/4 h-auto bg-base-100 shadow-2xl mb-10 mt-10 p-5">
        <p>
          This page is created by Tertiary Infotech to help you verify the
          authenticity of your certificates issued by Tertiary Courses. Your
          verification files are created with the use of OpenAttestation, which
          leverages blockchain technology to create a tamper-proof record of
          your certificate.
        </p>
        <br />
        <p>
          To verify your certificate, please drop your .tc file in the area
          below. Your certificate and verification results will be rendered
          automatically.
        </p>
      </div>
      <div className="card w-3/4 h-4/5 bg-base-100 shadow-2xl border-2 rounded-xl border-primary border-dashed">
        <div
          className="dropzone card-body flex items-center justify-center"
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        >
          <DocumentArrowUpIcon className="h-20 w-auto" />

          <input
            type="file"
            accept=".json"
            onChange={handleFileChange}
            style={{ display: "none" }}
            id="file-input"
          />
          <label
            htmlFor="file-input"
            className="text-center lg:text-2xl md:text-xl sm:text-lg cursor-pointer"
          >
            <p>Drop your .tc file here</p>
            <p className="font-bold">OR</p>
            <p>click here to browse</p>
          </label>
        </div>
      </div>
    </div>
  );
};

export default Dropzone;
